import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from 'axios';

const ProductsChart = () => {
  const [productData, setProductData] = useState([]);

  // Fonction pour récupérer les commandes et analyser les produits les plus commandés
  useEffect(() => {
    const fetchOrders = async () => {
      const response = await axios.get('http://127.0.0.1:5000/api/orders/top-products');  // Remplacez par l'URL de votre API
      const orders = response.data;
      const productCount = {};

      // Parcours des commandes et comptabilisation des produits
      orders.forEach(order => {
        order.items.forEach(item => {
          const productId = item.id;  // Assurez-vous que la structure correspond à votre base de données
          if (productCount[productId]) {
            productCount[productId] += 1;
          } else {
            productCount[productId] = 1;
          }
        });
      });

      // Transformation des données pour le graphique
      const products = Object.entries(productCount).map(([productId, count]) => ({
        productId,
        count,
      }));

      setProductData(products);
    };

    fetchOrders();
  }, []);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <h2>Produits les Plus Commandés</h2>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={productData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="productId" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProductsChart;
